import { Group } from '@mantine/core';
import React from 'react';

import { Label } from 'types';

import { LabelBadge } from './LabelBadge';

type LabelListProps = {
  labels: (Label | string)[];
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onRemove?: (label: Label | string) => void;
  maxDisplay?: number;
};

export function LabelList({ labels, size = 'sm', onRemove, maxDisplay }: LabelListProps) {
  const displayLabels = maxDisplay ? labels.slice(0, maxDisplay) : labels;
  const remainingCount = maxDisplay && labels.length > maxDisplay ? labels.length - maxDisplay : 0;

  return (
    <Group spacing="xs">
      {displayLabels.map((label) => {
        const isStringLabel = typeof label === 'string';
        const labelId = isStringLabel ? label : label._id;
        return (
          <LabelBadge
            key={labelId || `label-${Math.random()}`}
            label={label}
            size={size}
            onRemove={onRemove ? () => onRemove(label) : undefined}
          />
        );
      })}
      {remainingCount > 0 && (
        <LabelBadge
          label={`+${remainingCount} more`}
          size={size}
          style={{ backgroundColor: '#e9ecef', color: '#495057' }}
        />
      )}
    </Group>
  );
}
